import { Flex } from "@chakra-ui/react";
import { useSelector } from "react-redux";
import { getIsInDetachMode } from "src/duck/selectors";
import { Subtitle } from "src/atoms/typography";
import SvgContainer from "src/components/SvgContainer";
import { ReactComponent as ArrowRightIcon } from "./arrow-right.svg";

export default function LastEventSubtitle({
  onClick,
  subtitle,
  color = "mediumEmphasis",
  subtitleCss,
  fill = "mediumEmphasis",
  isInTileView,
  ...rest
}) {
  const isInDetachMode = useSelector(getIsInDetachMode);
  return (
    <Flex
      {...rest}
      onClick={() => {
        if (!isInDetachMode && !isInTileView) onClick();
      }}
      {...(isInDetachMode && {
        textAlign: "center",
        maxHeight: "7vmin"
      })}
    >
      <Subtitle
        // fontSize={[14, 20, 24]}
        fontSize="clamp(1.4rem, 2.67vmin, 2.4rem)"
        lineHeight={["16px", "22px", "28px"]}
        letterSpacing={["0.15px", "0.2px", "0.28px"]}
        color={color}
        {...subtitleCss}
        {...(isInDetachMode && {
          fontSize: "4.4vmin !important",
          lineHeight: "6.1vmin !important",
          mt: "0px !important"
        })}
        sx={{
          "@media (max-height: 200px)": {
            fontSize: "9px !important,"
          },
          "@media (max-width: 200px)": {
            fontSize: "9px !important,"
          }
        }}
      >
        {subtitle}
      </Subtitle>
      {!isInDetachMode && !isInTileView && (
        <SvgContainer mt={["1px", "2px", "4px"]} icon={ArrowRightIcon} size={["16px", "22px", "28px"]} fill={fill} />
      )}
    </Flex>
  );
}
